import { useLocation, useResolvedPath } from 'react-router-dom'
import { getRoutePath } from 'routes/routes'
import { useCallback} from 'react'

function useInRoute() {

  const location = useLocation()
  const resolvedPath = useResolvedPath(location)

  const inRouteName = useCallback((_route) =>{
    let routePath = getRoutePath(_route)
    return inRoute(routePath)
  },[resolvedPath.pathname])

  const inRoute = useCallback((_route)=> {
    return resolvedPath.pathname.startsWith(_route)
  },[resolvedPath.pathname])

  const HideInRoute = useCallback((_props) => {
    const {
      route = "/"
    } = _props
    if (inRoute(route)) {
      return null
    }
    return _props.children
  },[inRoute])

  const HideInRouteName = useCallback((_props) =>{
    const {
      routeName = "/"
    } = _props
    let route = getRoutePath(routeName)
    if (inRoute(route)) {
      return null
    }
    return _props.children
  },[inRoute])

  return [inRoute, { inRouteName, HideInRoute, HideInRouteName }]
}

export default useInRoute;